export default {
  male: {
    en: 'Male',
  },
  female: {
    en: 'Female',
  },
  unisex: {
    en: 'Unisex',
  },
}
